export const environment = {
  production: false,
  default_map_location: [-122.431297, 37.773972],
  default_map_zoom_level: 12,
  zoom_level: 18,
  refresh_rate: 80000,
  alerts: 'off',
  zoom_control: 'on',
  near_by_stops_color_code: '#000',
};
